/**
* Content Image Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Image Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-image-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-image-scroller' ).each( function( key, component ) {
        // get nav heights and whatnot
        const docStyle = getComputedStyle( document.documentElement );
        const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
        const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
        // -------

        // set up some variables
        const leftImages = $( this ).find( '.left-images' )[0];
        const rightImages = $( this ).find( '.right-images' )[0];
        const originalPanelHeight = $( this ).find( '.panel' ).height();
        const speed = 2; // higher is slower
        const panelHeight = originalPanelHeight * ( 1 + ( 0.25 * speed ) );
        const panelsCount = $( this ).find( '.panel' ).length;

        // set the height of the component to the desired speed
        $( component ).height( $( component ).find( '.panel' ).height() * ( panelsCount + speed ) );

        // pin the component
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            pin: $( component ).find( '.panels' )[0],
            start: 'top ' + topOffset,
            end: 'bottom bottom',
            scrub: 0,
          },
        } );

        // set up the image marquees, do some fancy math to only scroll the rest of the marquee rather than the WHOLE thing
        gsap.set( leftImages, {y: '0%'} );
        gsap.set( rightImages, {y: '0%'} );
        tl.to( leftImages, {y: ( ( originalPanelHeight - $( leftImages ).height() ) / 2 ) + 'px', ease: 'linear'}, 0 );
        tl.to( rightImages, {y: ( ( $( rightImages ).height() - originalPanelHeight ) / 2 ) + 'px', ease: 'linear'}, 0 );

        // scroll to appropriate panel when pagination is clicked
        $( component ).find( '.pagination-panel a' ).on( 'click', function() {
          window.scrollTo( {
            top: $( component ).position().top + ( panelHeight * $( this ).index() ) + 20,
            left: 0,
            behavior: 'smooth',
          } );
        } );

        // loop through each panel to set up the revealing of it
        $( component ).find( '.panel:not(:first-child)' ).each( function( panelKey, panel ) {
          // reveal the content
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: panel,
              start: ( panelHeight * ( panelKey ) ) + ' ' + topOffset,
              end: '+=' + panelHeight,
              onUpdate: ( self ) => {
                // show the panel when you enter it, and hide the previous one
                if ( self.progress < 0.01 ) {
                  if ( panelKey > 0 ) { // don't hide the first one when you go backwards
                    $( panel ).prev().find( '.content' ).addClass( 'is-active' );
                    $( panel ).find( '.content' ).removeClass( 'is-active' );
                  }
                } else {
                  $( panel ).prev().find( '.content' ).removeClass( 'is-active' );
                  $( panel ).find( '.content' ).addClass( 'is-active' );
                }

                // update the active page when it's related panel is hit
                if ( ( self.progress > 0.01 && self.progress < 0.99 ) || ( self.progress <= 0.01 && panelKey == 0 ) ) {
                  $( component ).find( '.pagination-panel a:nth-child(' + ( panelKey + 1 ) + ')' ).addClass( 'is-active' );
                } else {
                  $( component ).find( '.pagination-panel a:nth-child(' + ( panelKey + 1 ) + ')' ).removeClass( 'is-active' );
                }
              },
              scrub: 0,
            },
          } );
        } );

        $( component ).find( '.image-marquees' ).magnificPopup( {
          delegate: 'a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><img src="/wp-content/themes/renova/assets/img/arrow-%dir%.svg" width="18" height="15"/></button>',
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function( item ) {
              return item.el.attr( 'title' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-image-scroller', COMPONENT );
} )( app );
